"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigIconMenu = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const StyledButton = (0, styled_components_1.default)(core_1.IconButton) `
  .add-icon {
    color: #ccc;
  }
`;
const StyledPopover = (0, styled_components_1.default)(core_1.Menu) ``;
const ConfigIconMenu = (_a) => {
    var { options, onChange } = _a, props = __rest(_a, ["options", "onChange"]);
    const [value, setValue] = (0, react_1.useState)(props.value);
    const timerRef = (0, react_1.useRef)();
    const [anchorElement, setAnchorElement] = (0, react_1.useState)();
    // handle value reset from parent
    (0, react_1.useEffect)(() => setValue(value), [value]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledButton, { className: 'config-icon-menu', size: 'small', onClick: event => setAnchorElement(event.currentTarget) }, value ? react_1.default.createElement(core_1.Icon, null, value) : react_1.default.createElement(core_1.Icon, { className: 'add-icon' }, "add")),
        anchorElement && (react_1.default.createElement(StyledPopover, { anchorEl: anchorElement, keepMounted: true, open: Boolean(anchorElement), onClose: e => setAnchorElement(undefined), PaperProps: {
                style: {
                    width: 240,
                    overflow: 'hidden'
                }
            }, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center'
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'center'
            } }, options.map(option => {
            react_1.default.createElement(core_1.MenuItem, { key: option.value }, option.label);
        })))));
};
exports.ConfigIconMenu = ConfigIconMenu;
exports.default = exports.ConfigIconMenu;
//# sourceMappingURL=ConfigIconMenu.js.map